import { getCapitalizedPluralTargetNoun } from '#components/patterns/audit-log/type-string-maps.ts';
import { SelectItem } from '#components/patterns/forms/select/select-item/SelectItem.tsx';
import { Select } from '#components/patterns/forms/select/select/Select.tsx';
import type { TargetOption } from '../../../form-types.ts';

export const TARGET_TYPES: TargetOption[] = [
  'all',
  'apiKey',
  'ca',
  'joinKey',
  'host',
  'network',
  'role',
  'organization',
  'oidcProvider',
  'endpointOIDC',
  'googleIdP',
  'tag',
  'user',
];

export function getOptionName(option: TargetOption) {
  if (option === 'all') {
    return 'All logs';
  }

  if (option === 'ca') {
    return 'CAs';
  }

  if (option === 'oidcProvider') {
    return 'Admin SSO';
  }

  if (option === 'endpointOIDC') {
    return 'Endpoint SSO';
  }

  if (option === 'googleIdP') {
    return 'Google Workspace';
  }

  return getCapitalizedPluralTargetNoun(option);
}

type Props = {
  onChange: (selectedItem?: TargetOption | null) => void;
  value?: TargetOption;
  label: string;
} & Omit<React.ComponentProps<typeof Select<TargetOption>>, 'items' | 'label' | 'children'>;

export function TargetTypeSelect({ onChange, value = 'all', ...props }: Props) {
  return (
    <Select renderValue={getOptionName} value={value} {...props}>
      {TARGET_TYPES.map((tt) => (
        <SelectItem
          key={tt}
          value={tt}
          onClick={() => {
            onChange(tt);
          }}
        >
          {getOptionName(tt)}
        </SelectItem>
      ))}
    </Select>
  );
}
